import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithCredential, Auth } from 'firebase/auth';
import { getDatabase, enableLogging } from 'firebase/database';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

// CRA yalnızca REACT_APP_* değişkenlerini bundle’a enjekte eder (.env / build:usa için).
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDYK9d4_UpwAtOlqvqfwjWaDnF2EHXKfeI',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'mtgtsapp.firebaseapp.com',
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    'https://mtgtsapp-default-rtdb.firebaseio.com/',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'mtgtsapp',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'mtgtsapp.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '338071169045',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:338071169045:web:bef9acd26184a8fddac61c',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-61GNYX3GS1',
};

// ═══════════════════════════════════════════════════════════════════════════════
// MÜŞTERİ EKRANI (CustomerDisplay) TESPİTİ
// Müşteri ekranı penceresi açıldığında Firebase Auth'u initialize etmiyoruz.
// Bu, IndexedDB senkronizasyonunun ana penceredeki oturumu etkilemesini önler.
// ═══════════════════════════════════════════════════════════════════════════════
const isCustomerDisplayWindow = typeof window !== 'undefined' && (
  window.name === 'CustomerDisplay' || 
  window.location.hash.includes('/customer-display/')
);

if (isCustomerDisplayWindow) {
  console.log('🖥️ [Firebase] Müşteri ekranı penceresi tespit edildi - Auth initialize EDİLMEYECEK');
}

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// ═══════════════════════════════════════════════════════════════════════════════
// AUTH - Müşteri ekranında NULL, diğer pencerelerde normal
// ═══════════════════════════════════════════════════════════════════════════════
let authInstance: Auth | null = null;
if (!isCustomerDisplayWindow) {
  authInstance = getAuth(app);
}
export const auth = authInstance as Auth; // Type assertion - AuthContext null kontrolü yapacak

// ═══════════════════════════════════════════════════════════════════════════════
// DİĞER SERVİSLER
// ═══════════════════════════════════════════════════════════════════════════════
export const database = getDatabase(app);

// ── GEÇİCİ TANI: RTDB kaynak izleme (Faz 7.5 doğrulama) ─────────────────────────
// Firebase RTDB SDK'sinin tum tel-seviyesi trafigini [SOURCE:RTDB] etiketiyle yazar.
// Boylece (auth disinda) hangi verinin HALA RTDB'den geldigi/yazildigi gorulur — hangi
// dosyanin ref/get/set cagirdigi onemli degil, hepsi SDK'nin tek logger'indan gecer.
// Yalniz development'ta aktif; konsolu "[SOURCE:RTDB]" ile filtreleyin.
// Tani bitince bu blogu ve enableLogging importunu kaldirin.
if (process.env.NODE_ENV !== 'production' && !isCustomerDisplayWindow) {
  try {
    enableLogging((message: string) => {
      // eslint-disable-next-line no-console
      console.log('[SOURCE:RTDB]', message);
    });
  } catch (e) {
    // enableLogging desteklenmiyorsa yok say
  }
}

// Analytics - sadece ana pencerede (müşteri ekranında gereksiz)
let analyticsInstance: Analytics | null = null;
if (!isCustomerDisplayWindow && typeof window !== 'undefined') {
  try {
    analyticsInstance = getAnalytics(app);
  } catch (e) {
    console.warn('Analytics başlatılamadı:', e);
  }
}
export const analytics = analyticsInstance as Analytics;

export const storage = getStorage(app);
export { GoogleAuthProvider, signInWithCredential };
export default app; 